/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Release_ReleaseValidationResult } from '../models/Wealthlane_AwardService_Dtos_Release_ReleaseValidationResult';
import type { Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto } from '../models/Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto';
import type { Wealthlane_Shared_Hosting_Etos_ReleaseItemImport_CreateReleaseImportEto } from '../models/Wealthlane_Shared_Hosting_Etos_ReleaseItemImport_CreateReleaseImportEto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseItemImportService {

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Release_ReleaseValidationResult OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseItemImportReleaseFromDto(
        requestBody?: Wealthlane_AwardService_Dtos_Release_UpdateReleaseDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Release_ReleaseValidationResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-item-import/release-from-dto',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseItemImportBackgroundCreateReleaseFromDto(
        requestBody?: Wealthlane_Shared_Hosting_Etos_ReleaseItemImport_CreateReleaseImportEto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-item-import/background-create-release-from-dto',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
